import  { useEffect } from 'react'
import "./admin.css"
import AdminMain from './AdminMain'
const Dashboard = () => {

  useEffect(() => {
    window.scrollTo(0,0)
   }, [])
   
  return (
    <section className="admin-dashboard">
    <AdminMain />
  </section>
  )
}

export default Dashboard